import { tw } from 'utils/classnames'

interface ProductHighlightProps {
  children: React.ReactNode
  className?: string
}

export function ProductHighlight({ className, children }: ProductHighlightProps) {
  return (
    <div
      className={tw(
        'text-12 inline-flex w-full flex-nowrap items-center justify-start gap-[6px]',
        className,
      )}
    >
      {children}
    </div>
  )
}
